import * as React from "react";
import {useEffect, useContext} from "react";
import {Comment} from "../queries/comment";
import {Like} from "../queries/like";
import {CommentContext} from "../context/commentContext";

export const useComments = (eventId) => {
    const {state, dispatch} = useContext(CommentContext);
    useEffect(()=> {
        console.log(state.length === 0);
        state.length === 0 &&
        Comment.fetchComment(eventId).then((response) => dispatch({type: "initComment",payload:response}))
    },[])

    const addComment = (text) => {
        Comment.postComment(text,eventId).then(() => {
            Comment.fetchComment(eventId).then((response) => dispatch({type: "initComment",payload:response}))
        });
    }

    return {addComment,commentList:state,commentCount:state.length}
}

export const useRemoveComment = (eventId) => {
    const {dispatch} = useContext(CommentContext);
    const removeComment = (commentId) => {
        dispatch({type:'removeComment',payload:commentId});
        Comment.removeComment(commentId).then(() => {
            Comment.fetchComment(eventId).then((response) => dispatch({type: "initComment",payload:response}))
        });
    }

    return {removeComment}
}

export const useLikeComment = () => {
    const {dispatch} = useContext(CommentContext);
    const likeComment = (commentId) => {
        console.log(commentId);
        Like.addLike('comment',commentId);
        dispatch({type:'likeComment',payload:commentId});
    }
    return {likeComment}
}

export const useDislikeComment = () => {
    const {dispatch} = useContext(CommentContext);
    const dislikeComment = (commentId) => {
        Like.removeLike('comment',commentId);
        dispatch({type:'dislikeComment',payload:commentId});
    }
    return {dislikeComment}
}
